import { render, staticRenderFns } from "./imgaddwater.vue?vue&type=template&id=7d3615de&scoped=true"
import script from "./imgaddwater.vue?vue&type=script&lang=js"
export * from "./imgaddwater.vue?vue&type=script&lang=js"
import style0 from "./imgaddwater.vue?vue&type=style&index=0&id=7d3615de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3615de",
  null
  
)

export default component.exports